<!-- <div class="my-store">
	<div class="my-store__box">
		<div class="my-store__box--top">
			<svg width="42" height="38" viewBox="0 0 42 38">
				<g fill="transparent" fill-rule="evenodd" stroke="#0CC5D1" stroke-width="2">
					<path stroke-linecap="square"
						d="M5.455 19L5.455 35.364 34.545 35.364 34.545 19M5.455 0L0 9.09c-.006 2.525 1.726 4.722 4.182 5.306 2.456.583 4.99-.6 6.122-2.856.914 1.841 2.792 3.006 4.848 3.006S19.086 13.38 20 11.54c.914 1.841 2.792 3.006 4.848 3.006s3.934-1.165 4.848-3.006c1.131 2.257 3.666 3.44 6.122 2.856 2.456-.584 4.188-2.78 4.182-5.305L34.545 0H5.455z"
						transform="translate(1 1)" />
					<path d="M16.364 35.364L16.364 24.455 23.636 24.455 23.636 35.364" transform="translate(1 1)" />
				</g>
			</svg>
			<h2 i18n="@@my_catalogue">My Catalogue</h2>
			<p *ngIf="userInfo?.store_type == 'product'" i18n="@@store.product">Your Products</p>
			<p *ngIf="userInfo?.store_type == 'service'" i18n="@@store.service">Your Services</p>
		</div>
		<div class="my-store__box--main">
			<h3 i18n="@@store.welcome_header">Welcome to Your Catalogue!</h3>

			<p *ngIf="userInfo?.store_type == 'product'" i18n="@@store.product_welcome_message">Your catalogue allows you to list your products to your Teem account for ease of filling out your invoices. Add product prices, special offers and more.</p>
			<p *ngIf="userInfo?.store_type == 'service'" i18n="@@store.service_welcome_message">Your catalogue allows you to list your services to your Teem account for ease of filling out your invoices. Add service prices, special offers and more.</p>

			<a *ngIf="userInfo?.store_type == 'product';" (click)="onAddClick.emit()" href="javascript:void(0)" class="tu-btn pink" i18n="@@store.add_first_product">Add Your First Product </a>
			<a *ngIf="userInfo?.store_type == 'service' ;" (click)="onAddClick.emit()" href="javascript:void(0)" class="tu-btn pink" i18n="@@store.add_first_service">Add Your First Service</a>

			<div>
				<button href="javascript:void(0)" (click)="openImportModal()" class="tu-btn transparent" >
					<span i18n="@@common.import">Import .xls</span>
				</button>
			</div>			
			
		</div>
	</div>
</div> -->
<div class="tab-content data-table__tab-content" id="pills-tabContent">
	<div class="tab-pane fade show active" id="pills-all-store" role="tabpanel" aria-labelledby="pills-all-store-tab">
		
		<img class="emty_img" src="https://test.teem-app.com/teem-ui/images/NoUpcomingTrips3x.svg" alt="" loading="lazy">
		
		<h2 class="empty_orders" i18n="@@store.welcome_header">Welcome to Your Catalogue!</h2>
		
		<p class="p-5" *ngIf="userInfo?.store_type == 'product'" i18n="@@store.product_welcome_message">Your catalogue allows you to list your products to your Teem account for ease of filling out your invoices. Add product prices, special offers and more.</p>
		<p class="p-5" *ngIf="userInfo?.store_type == 'service'" i18n="@@store.service_welcome_message">Your catalogue allows you to list your services to your Teem account for ease of filling out your invoices. Add service prices, special offers and more.</p>
		
		<button class="d-flex add_new_invoice_btn mt-4" *ngIf="userInfo?.store_type == 'product';" (click)="onAddClick.emit()">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				<path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			<ng-container i18n="@@store.add_first_product">Add Your First Product</ng-container>			
		</button>
		
		<button class="d-flex add_new_invoice_btn mt-4" *ngIf="userInfo?.store_type == 'service';" (click)="onAddClick.emit()">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
				<path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			<ng-container i18n="@@store.add_first_service">Add Your First Service</ng-container>			
		</button>
		
		<button class="d-flex import_btn transparent mt-4 mb-3" (click)="openImportModal()">
			<ng-container i18n="@@common.import">Import .xls</ng-container>			
		</button>

	</div>
</div>